import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Wikis"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5ZM21 11.25H16.5C16.4125 8.48783 15.6969 5.78188 14.4075 3.33751C18.0461 4.3328 20.6779 7.49156 21 11.25ZM12 21C11.8327 21.0112 11.6648 21.0112 11.4975 21C9.94371 18.5221 9.08138 15.6736 9 12.75H15C14.9254 15.6715 14.0709 18.5199 12.525 21C12.3502 21.0123 12.1748 21.0123 12 21ZM9 11.25C9.07461 8.32853 9.92913 5.48013 11.475 3.00002C11.8089 2.96249 12.1461 2.96249 12.48 3.00002C14.0417 5.47562 14.9119 8.32431 15 11.25H9ZM9.57 3.33751C8.28847 5.78375 7.58059 8.4896 7.5 11.25H3C3.32214 7.49156 5.95394 4.3328 9.5925 3.33751H9.57ZM3.03755 12.75H7.53755C7.61582 15.5098 8.32113 18.2156 9.60005 20.6625C5.97329 19.6566 3.35542 16.5002 3.03755 12.75ZM14.4075 20.6625C15.6969 18.2181 16.4125 15.5122 16.5 12.75H21C20.6779 16.5084 18.0461 19.6672 14.4075 20.6625Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Wikis.vue"]]);
